<template>
  <div class="information">
    <div class="info-top">
      <div class="mess-con">
        <div class="mess-text">
          <div class="top-mess">{{countryMe.ApplicationEmpowerment}}</div>
          <!-- <div class="top-message">{{countryMe.ApplicationEmpowermentTxt}}</div> -->
        </div>
      </div>
      <!-- <img src="@/assets/my/head.jpg" alt="">
      <div class="top-mess">{{countryMe.ApplicationEmpowerment}}</div>
      <div class="top-message">{{countryMe.ApplicationEmpowermentTxt}}</div> -->
    </div>
    <div class="info-content">
      <div class="info">
        <div class="info-header"></div>
        <div class="info-title" :class="$i18n.locale=='zh' ? '' : 'bot-tit-en'">
          {{countryMe.OverseasCases}}
          <div class="bot-bg">Overseas cases</div>
        </div>
      </div>
      <div class="cooperate" v-if="$i18n.locale === 'en'">
        <div v-loading="Loading" class="swiper8">
          <div class="swiper-wrapper">
            <div class="swiper-slide cont-list cont-special" v-for="(item, index) in dataWpsBlue" :key="index" @click="open(item.case_pdf)">
              <div class="photo-box"><img :src="item.case_picture" alt="" /></div>
              <div class="title-box">
                {{ item.english_case_name }}
              </div>
              <!-- <div class="title-box" v-else>
                {{ item.case_name }}
              </div> -->
            </div>
          </div>
          <!-- 如果需要导航按钮 -->
          <div class="swiper-button-prev"><img src="@/assets/img/left.png" alt=""></div>
          <div class="swiper-button-next"><img src="@/assets/img/right.png" alt=""></div>
        </div>
      </div>
      <div class="cooperate" v-else>
        <div v-loading="Loading" class="swiper8">
          <div class="swiper-wrapper">
            <div class="swiper-slide cont-list cont-special" v-for="(item, index) in dataWpsBlue" :key="index" @click="open(item.case_pdf)">
              <div class="photo-box"><img :src="item.case_picture" alt="" /></div>
              <div class="title-box">
                {{ item.case_name }}
              </div>
            </div>
          </div>
          <!-- 如果需要导航按钮 -->
          <div class="swiper-button-prev"><img src="@/assets/img/left.png" alt=""></div>
          <div class="swiper-button-next"><img src="@/assets/img/right.png" alt=""></div>
        </div>
      </div>
      <!-- <div class="special">
        <div class="info">
          <div class="info-header"></div>
          <div class="info-title">
            {{countryMe.Partners}}
            <div class="bot-bg">Cooperative companies</div>
          </div>
        </div>
        <div class="cooperate">
          <div v-loading="Loading" class="swiper7">
            <div class="swiper-wrapper">
              <div class="swiper-slide cont-list" v-for="(item, index) in dataHyhd" :key="index">
                <div class="photo-box"><img :src="item.company_picture" alt="" /></div>
                <div class="tips">
                  {{ item.company_name }}
                </div>
              </div>
            </div>
            <div class="swiper-button-prev"><img src="@/assets/img/left.png" alt=""></div>
            <div class="swiper-button-next"><img src="@/assets/img/right.png" alt=""></div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/css/swiper.min.css";
import mock from "../../../public/json/应用赋能-出海案例.json";
import mock2 from "../../../public/json/应用赋能-合作公司.json";
export default {
  name: 'countryMe',
  data() {
    return {
      show: 1,
      dataWpsBlue: [],
      dataHyhd: [],
      Loading: true
    }
  },
  // beforeRouteEnter(to, from, next) {
  //   next(vm => {
  //     vm.delLoop();
  //   });
  // },
  watch: {
    '$i18n.locale'() {
      console.log(999999999)
      this.Loading = true
      setTimeout(() => {
        this.delLoop()
      }, 3000)
    }
  },
  mounted() {
    this.dataWpsBlue = mock["RECORDS"];
    this.dataHyhd = mock2["RECORDS"];
    setTimeout(() => {
      this.Loading = true
      this.delLoop()
    }, 3000)
    // this.delLoop()
  },
  computed:{
    countryMe(){
      return this.$t('countryMe')
    },
  },
  methods: {
    delLoop() {
      new Swiper(".swiper7", {
        // direction: "vertical", // 垂直切换选项
        loop: true, // 循环模式选项
        // 如果需要前进后退按钮
        autoplay: {
          delay: 4000, // 自动轮播时间间隔（单位：毫秒）
          disableOnInteraction: false, // 用户操作后是否禁用自动轮播
        },
        slidesPerView: 4,
        spaceBetween: 12,
        slidesPerGroup: 1,
        grid: {
          rows: 2,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
      new Swiper(".swiper8", {
        slidesPerView: 4,
        spaceBetween: 12,
        slidesPerGroup: 1,
        autoplay: {
          delay: 4000, // 自动轮播时间间隔（单位：毫秒）
          disableOnInteraction: false, // 用户操作后是否禁用自动轮播
        },
        // direction: "vertical", // 垂直切换选项
        loop: true, // 循环模式选项
        // 如果需要前进后退按钮
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
      this.Loading = false
    },
    open(src) {
      window.open(src)
    }
  }
}
</script>

<style lang="scss" scoped>
.information {
  width: 100%;
  .info-top {
    .mess-con {
      height: 180px;
      max-width: 1200px;
      margin: 0 auto;
      background: url('@/assets/my/head.jpg') no-repeat;
      background-size: 100% 100%;
      .mess-text {
        max-width: 1200px;
        margin: 0 auto;
        text-align: left;
        padding: 0px 0 0 0;
        height: 180px;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
    }
    div {
      font-family: Inter;
      color: #fff;
      font-weight: 500;
    }
    .top-mess {
      font-weight: 500;
      font-size: 36px;
      line-height: 36px;
      padding-left: 2vw;
      box-sizing: border-box;
    }
    .top-message {
      font-size: 20px;
      line-height: 27px;
      margin-top: 20px;
      padding-left: 2vw;
      box-sizing: border-box;
    }
  }
  .info-content {
    width: 100%;
    box-sizing: border-box;
    padding: 60px 0 0px 0;
    background: #fff;
    .info {
      margin-bottom: 20px;
      .info-header {
        width: 84px;
        height: 4px;
        background: linear-gradient( 270deg, #1D3E95 0%, #4840C2 100%);
        border-radius: 4px 4px 4px 4px;
        margin: 0 auto 22px;
      }
      .info-title {
        margin: 0 auto;
        margin-top: 22px;
        height: 40px;
        font-family: Inter;
        font-weight: 400;
        font-size: 36px;
        color: #080808;
        line-height: 40px;
        position: relative;
        .bot-bg {
          height: 50px;
          font-family: Inter;
          font-weight: 700;
          font-size: 36px;
          color: rgba(194, 194, 194, 0.12);
          line-height: 50px;
          text-align: center;
          position: absolute;
          top: 5px;
          left: 50%;
          transform: translate(-50%, 0);
          white-space: nowrap;
        }
      }
    }
  }
  .cooperate {
    max-width: 1200px;
    margin: 0 auto;
    margin-top: 42px;
    margin-bottom: 60px;
    ::v-deep .el-carousel__arrow {
      width: 60px;
      height: 60px;
    }
    .el-carousel {
      background-color: transparent;
    }
    .cont-list {
      display: flex;
      flex-wrap: wrap;
      margin: 2px 0;
      width: 300px;
      &:nth-child(4n) {
        margin-right: 0px;
      }
      .photo-box {
        height: 520px;
        // border: 1px solid #eee;
        img {
          border: 1px solid #eee;
        }
      }
      img {
        width: 100%;
        height: auto;
      }
      .title-box {
        box-sizing: border-box;
        height: 70px;
        padding: 0px 2px;
        width: 100%;
        font-size: 12px;
        // text-align: left;
      }
      .special-box {
        height: 58px !important;
      }
    }
  }
  .special {
    // background: #F5F7FA;
    width: 100%;
    padding: 40px 0 60px;
    margin-top: 20px;
  }
}
.swiper7,.swiper8{
  max-width: 1200px;
  margin: 0 auto;
  height: 600px;
  overflow: hidden;
  position: relative;
  .swiper-button-prev {
    width: 60px;
    height: 60px;
    font-size: 24px;
    background: rgba(8,8,8,0.7);
    border-radius: 50%;
    color: #fff;
    img {
      width: 25px;
      height: 25px;
    }
    &::after {
      content: '';
    }
  }
  .swiper-button-next {
    width: 60px;
    height: 60px;
    background: rgba(8,8,8,0.7);
    border-radius: 50%;
    color: #fff;
    img {
      width: 25px;
      height: 25px;
    }
    &::after {
      content: '';
    }
  }
  .swiper-slide {
    text-align: center;
  }
}
.swiper7 {
  height: 286px;
  .cont-list {
    display: flex;
    flex-direction: column;
  }
  .photo-box {
    height: 240px !important;
    img {
      // width: 282px !important;
      width: 100% !important;
      height: 282px !important;
      box-sizing: border-box;
      border: 1px solid #eee;
    }
  }
  .tips {
    height: 62px;
    line-height: 62px;
    background: #fff;
    font-family: Inter;
    font-weight: 700;
    font-size: 16px;
    color: #333640;
    text-align: left;
    font-style: normal;
    text-transform: none;
    // padding-left: 5px;
    box-sizing: border-box;
    width: 282px;
    margin: 0 auto;
    // border-top: 1px solid #ccc;
    white-space:nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
    text-align: center;
  }
}
.cont-special {
  cursor: pointer;
}
@media (max-width: 600px) {
  .info-top {
    .top-mess {
      top: -16% !important;
      left: 15% !important;
      font-size: 20px !important;
    }
    .top-message {
      // top: 40% !important;
      left: 15% !important;
      margin-top: 0px !important;
      font-size: 14px !important;
      text-align: left;
      display: -webkit-box;
      -webkit-line-clamp: 1; //显示最大行数
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .el-form {
    white-space: normal !important;
    text-align: left;
    &>div {
      margin-top: 8px;
    }
  }
  .left-btn > div {
    margin-right: 10px !important;
  }
  .trend-input {
    display: unset !important;
  }
  .page-text {
    width: 100px !important;
  }
  .content-photo {
    display: none !important;
  }
  .swiper8 {
    // width: 1200px;
    margin: 0 auto;
    height: 210px;
    overflow: hidden;
    position: relative;
    .swiper-button-prev {
      width: 40px;
      height: 40px;
      font-size: 24px;
      background: rgba(8,8,8,0.7);
      border-radius: 50%;
      color: #fff;
      img {
        width: 25px;
        height: 25px;
      }
      &::after {
        content: '';
      }
    }
    .swiper-button-next {
      width: 40px;
      height: 40px;
      background: rgba(8,8,8,0.7);
      border-radius: 50%;
      color: #fff;
      img {
        width: 25px;
        height: 25px;
      }
      &::after {
        content: '';
      }
    }
    .swiper-slide {
      text-align: center;
    }
    .cont-list {
      display: flex;
      flex-wrap: wrap;
      margin: 2px 0;
      width: 300px;
      &:nth-child(4n) {
        margin-right: 0px;
      }
      .photo-box {
        height: 169px !important;
      }
      img {
        width: 100%;
        height: auto;
      }
      .title-box {
        box-sizing: border-box;
        // height: 64px;
        height: 32px !important;
        line-height: 16px !important;
        padding: 0 5px;
        width: 100%;
        display: -webkit-box;
        -webkit-line-clamp: 2; //显示最大行数
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .special-box {
        height: 58px !important;
      }
    }
  }
  .swiper7 {
    height: 110px !important;
    .cont-list {
      display: flex;
      flex-direction: column;
    }
    .photo-box {
      height: 90px !important;
      img {
        width: 90px !important;
        height: 90px !important;
      }
    }
    .swiper-button-prev {
      width: 40px;
      height: 40px;
      font-size: 24px;
      background: rgba(8,8,8,0.7);
      border-radius: 50%;
      color: #fff;
      img {
        width: 25px;
        height: 25px;
      }
      &::after {
        content: '';
      }
    }
    .swiper-button-next {
      width: 40px;
      height: 40px;
      background: rgba(8,8,8,0.7);
      border-radius: 50%;
      color: #fff;
      img {
        width: 25px;
        height: 25px;
      }
      &::after {
        content: '';
      }
    }
    .tips {
      height: 62px;
      line-height: 16px !important;
      background: #fff;
      font-family: Inter;
      font-weight: 700;
      font-size: 12px;
      color: #333640;
      text-align: left;
      font-style: normal;
      text-transform: none;
      // padding-left: 5px;
      box-sizing: border-box;
      width: 90px !important;
      // border-top: 1px solid #ccc;
      // white-space:nowrap;
      // overflow:hidden;
      // text-overflow:ellipsis;
      white-space: normal !important;
      overflow: unset !important;
      text-overflow: unset !important;
    }
  }
  .bot-bg {
    font-size: 30px !important;
  }
  .mess-con {
    height: 150px !important;
    padding: 0 2vw;
    box-sizing: border-box;
  }
  .special {
    padding: 40px 0 20px !important;
  }
}
.bot-tit-en {
  font-weight: 600 !important;
}
</style>
